
const DataTabDataAPI = (response) => {

    var keys = Object.keys(response.data[0]);
    var fields = [];
    var titulo = response.data[0].titulo;

    for (let index = 0; index < keys.length; index++) {
        fields.push(
            { field: keys[index] }
        )
    }


    return { titulo: titulo, datos: response.data, fields: fields }



}

export default DataTabDataAPI




